"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormBuilder = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const spinner_1 = require("@pulse-web-ui/spinner");
const utils_1 = require("@pulse-web-platform-core/utils");
const components_1 = require("./components");
const form_builder_style_1 = require("./form-builder.style");
const utils_2 = require("./utils");
exports.FormBuilder = (0, react_1.memo)((props) => {
    const { params, components, isHeaderVisible = true, isFooterVisible = true, isStickyFooter = false, isSubmitVisible = true, isBannerVisible, contentWidth, debugMode, } = props;
    const { activeStep, wantNextStep, loading, setCurrentStep, productFormState, setDisableForm, onBackClick, isShowBackButton, isPolicyBanned, goBack, } = params;
    const navigate = (0, react_router_dom_1.useNavigate)();
    const location = (0, react_router_dom_1.useLocation)();
    const isIOS = (0, utils_1.detectIOS)();
    const scrollWrapperRef = (0, react_1.useRef)(null);
    const isBackButtonVisible = !!(activeStep > 1 && isShowBackButton) && !isPolicyBanned;
    const isShowBanner = (0, react_1.useMemo)(() => {
        var _a;
        const filteredBannerItems = (_a = components === null || components === void 0 ? void 0 : components.banner) === null || _a === void 0 ? void 0 : _a.filter(({ step }) => step === -1 || step === activeStep);
        return isBannerVisible && !!filteredBannerItems.length;
    }, [components.banner, activeStep, isBannerVisible]);
    (0, react_1.useEffect)(() => {
        var _a;
        if ((_a = location.state) === null || _a === void 0 ? void 0 : _a.activeStep) {
            setCurrentStep(location.state.activeStep);
            navigate('.', { state: { activeStep: null } });
            return;
        }
        setCurrentStep(activeStep);
    }, [activeStep]);
    (0, react_1.useEffect)(() => {
        if (wantNextStep) {
            if (scrollWrapperRef === null || scrollWrapperRef === void 0 ? void 0 : scrollWrapperRef.current) {
                scrollWrapperRef.current.scrollTop = 0;
            }
        }
    }, [wantNextStep]);
    const defaultValues = (0, react_1.useMemo)(() => (0, utils_2.getDefaultValues)(components, productFormState), [components]);
    const handleScroll = (e) => {
        if (isIOS &&
            (e.currentTarget.scrollHeight - e.currentTarget.scrollTop ===
                e.currentTarget.clientHeight ||
                e.currentTarget.scrollTop === 0)) {
            if (scrollWrapperRef.current) {
                scrollWrapperRef.current.style.overflow = 'hidden';
            }
        }
    };
    const handleTouchStart = () => {
        var _a, _b;
        if (isIOS && ((_b = (_a = scrollWrapperRef === null || scrollWrapperRef === void 0 ? void 0 : scrollWrapperRef.current) === null || _a === void 0 ? void 0 : _a.style) === null || _b === void 0 ? void 0 : _b.overflow) === 'hidden') {
            scrollWrapperRef.current.style.overflow = 'auto';
        }
    };
    const handleOnClickBack = (0, react_1.useCallback)(() => {
        if (onBackClick)
            onBackClick();
        setDisableForm(false);
        goBack();
    }, [goBack, setDisableForm, onBackClick]);
    const formBuilderIsReady = (0, react_1.useMemo)(() => Object.keys(defaultValues).length > 0, [defaultValues]);
    if (loading) {
        return (0, jsx_runtime_1.jsx)(spinner_1.Spinner, {});
    }
    return ((0, jsx_runtime_1.jsx)(form_builder_style_1.FormBuilderWrapper, { isBannerVisible: isShowBanner, contentWidth: contentWidth, children: (0, jsx_runtime_1.jsxs)(form_builder_style_1.FormBuilderScrollWrapper, { ref: scrollWrapperRef, onScroll: handleScroll, onTouchStart: handleTouchStart, children: [isHeaderVisible && ((0, jsx_runtime_1.jsx)(components_1.FormBuilderHeader, { components: components.header })), formBuilderIsReady && ((0, jsx_runtime_1.jsx)(components_1.FormBuilderStep, { components: components, defaultValues: defaultValues, params: params, isBackButtonVisible: isBackButtonVisible, isSubmitVisible: isSubmitVisible, isFooterVisible: isFooterVisible, isStickyFooter: isStickyFooter, handleOnClickBack: handleOnClickBack, isBannerVisible: isShowBanner, contentWidth: contentWidth, debugMode: debugMode }))] }) }));
});
exports.FormBuilder.displayName = 'FormBuilder';
